export default __webpack_public_path__ + "static/media/reminderimage.06902559.svg";